import React from 'react';
import styles from './Skeletons.module.css';

const barHeights = ['45%', '70%', '55%', '90%', '75%', '40%', '30%'];

function BarChartSkeleton() {
    return (
        <div className={styles.barChartSkeleton}>
            {barHeights.map((height, index) => (
                <div key={index} className={styles.barChartSkeletonBar} style={{ height }} />
            ))}
        </div>
    );
}

export default BarChartSkeleton;
